<template>
  <div class="headbar-content">
    <div>
      <a-icon class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="$emit('toggleCollapsed')" />
    </div>
    <div class="headbar-user">
      <a-dropdown :trigger="['click']">
        <span class="trigger username">
          {{username}}
          <a-icon type="down" />
        </span>
        <a-menu slot="overlay">
          <a-menu-item @click="$router.push('/page/user/set_password')">
            <span>修改密码</span>
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item @click="logout">
            <span>退出登录</span>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie';

  export default {
    name: 'Headbar',
    props: ['collapsed', 'username'],
    inject: ['reloadPage'],
    data() {
      return {
      };
    },
    methods: {
      initData() {
      },
      logout() {
        Cookies.remove('access');
        Cookies.remove('refresh');
        this.$router.push('/page/user/login');
      }
    },
    mounted() {
      this.initData();
    },
  }
</script>

<style scoped>
  .headbar-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
  }

  .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
  }

  .trigger:hover {
    color: #1890ff;
  }

  .headbar-user {
    min-width: 0;
  }

  .username {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    max-width: 42vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  @media (max-width: 768px) {
    .headbar-content {
      height: 52px;
    }

    .trigger {
      line-height: 52px;
      padding: 0 14px;
    }
  }
</style>
